import PageHeader from "@/components/PageHeader";
import CTASection from "@/components/CTASection";
import { NEWS } from "@/data/content";
import { ArrowUpRight, Calendar } from "lucide-react";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";
import { useContent } from "@/hooks/useContent";
import { resolveMedia } from "@/lib/media";

const News = () => {
  useDocumentTitle("News & Events");
  const { items } = useContent("news", NEWS);
  return (
    <div data-testid="news-page">
      <PageHeader
        eyebrow="News & Events"
        title="Announcements, research and updates."
        description="Company news, research publications, workshops and scientific events."
        breadcrumb={[{ label: "Home", to: "/" }, { label: "News" }]}
      />

      <section className="py-20 lg:py-24 border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 gap-6">
          {items.map((n, i) => (
            <article
              key={n.id || n.title}
              data-testid={`news-item-${i}`}
              className="group bg-white border border-slate-200 rounded-xl overflow-hidden hover:shadow-lg hover:border-sky-300 transition-all"
            >
              {n.cover_image_url && (
                <div className="aspect-[16/9] overflow-hidden bg-slate-100">
                  <img
                    src={resolveMedia(n.cover_image_url)}
                    alt={n.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
              )}
              <div className="p-8">
                <div className="flex items-center gap-3 text-xs text-slate-500 uppercase tracking-widest">
                  {n.date && (
                    <span className="inline-flex items-center gap-1.5">
                      <Calendar className="w-3.5 h-3.5" strokeWidth={1.5} />
                      {n.date}
                    </span>
                  )}
                  {n.tag && <span className="text-amber-600 font-medium">{n.tag}</span>}
                </div>
                <h3 className="mt-4 font-display text-xl lg:text-2xl font-semibold text-[#0B1B3D] leading-snug">
                  {n.title}
                </h3>
                {n.excerpt && (
                  <p className="mt-3 text-slate-600 leading-relaxed">{n.excerpt}</p>
                )}
                <div className="mt-5 inline-flex items-center gap-1.5 text-xs uppercase tracking-widest text-[#0B1B3D] group-hover:text-amber-600 transition-colors font-medium">
                  Read announcement
                  <ArrowUpRight className="w-3.5 h-3.5" />
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>

      <CTASection
        eyebrow="Newsletter"
        title="Get research and product updates by email."
        description="No spam. Only meaningful updates from our engineering and research teams."
      />
      <div className="py-24" />
    </div>
  );
};

export default News;
